<template>
	<widget title="Job Safety Tasks" icon="fa-list">

		<freemium-locked-alert v-if="$store.company.is_freemium == 1"></freemium-locked-alert>

		<p>A database of Job tasks and their associated hazards and controls. Keeping a comprehensive list here makes Safety Analyses easier to create and fill out.</p>

		<modal-dialog 
			:modal-visible="modalVisible"
			title="Add/Edit Job Safety Tasks"
			:working="modalWorking"
			confirm-button-text="Save"
			button-class="btn-success"
			v-on:closeModal="modalVisible = false"
			v-on:confirm="saveTask">

			<field label="Task Description"
				col-class="col-md-4"
				v-model="payload.description">
			</field>

			<field label="Associated Hazards"
				col-class="stacked"
				v-model="payload.SafetyHazard"
				:params="{type:'select-multi',options:hazardOptions}">
			</field>

			<field label="Associated Controls"
				col-class="stacked"
				v-model="payload.SafetyControl"
				:params="{type:'select-multi',options:controlOptions}">
			</field>

		</modal-dialog >

		<table-list
			:records="mutatedTasks"
			:fields="fields"
			record-name="Job Safety Task"
			:hide-record-count="true"
			:has-delete="true"
			:has-edit="true"
			:sortable="true"
			delete-endpoint="/SafetyJobTask/delete"
			v-on:edit="editTask"
			v-on:modelChange="fetchData(true)">

			<button class="btn btn-success" v-on:click="addTask">
				<i class="fa fa-plus"></i>
				Add New Task
			</button>

		</table-list>

	</widget>
</template>
<script type="text/javascript">
import Widget from "@/components/Widget"
import TableList from "@/components/TableList"
import Field from "@/components/Field"
import ModalDialog from "@/components/ModalDialog"
import FreemiumLockedAlert from "@/components/FreemiumLockedAlert"

export default {
	name: "JobSafetyTasksManagerWidget",
	components: {
		Widget,
		TableList,
		Field,
		ModalDialog,
		FreemiumLockedAlert
	},
	data() {
		return {
			payload: {
				description: "",
				hazards: [],
				controls: []
			},
			modalWorking:false,
			modalVisible: false,
			hazards: [],
			controls: [],
			tasks: [],
			fields: [
				{label: "Task Description",key:"description"},
				{label: "Hazards",key: "hazardCnt"},
				{label: "Controls",key: "controlCnt"}	
			]
		}
	},
	computed: {
		mutatedTasks() {
			if (this.tasks) {
				return this.tasks.map(task => {
					task.hazardCnt = task.SafetyHazard.length
					task.controlCnt = task.SafetyControl.length

					return task
				})
			}
			return []
		},
		hazardOptions() {
			return this.optionify(this.hazards,"description")
		},
		controlOptions() {
			return this.optionify(this.controls,"description")
		}
	},
	methods: {
		addTask() {
			this.payload = {
				description: "",
				SafetyHazard: [],
				SafetyControl: []
			}

			this.modalVisible = true
		},
		editTask(task) {
			this.payload.id = task.id
			this.payload.description = task.description

			this.payload.SafetyHazard = this.primitize(task.SafetyHazard)
			this.payload.SafetyControl = this.primitize(task.SafetyControl)

			this.modalVisible = true
		},
		saveTask() {
			let vm = this

			vm.modalWorking = true

			this.postData("SafetyJobTask/save",this.payload,true).then(response => {
				vm.modalWorking = false

				if (response.success) {
					vm.modalVisible = false
					vm.fetchData(true)
				}
			})
		},
		fetchData(spinner) {
			let vm = this

			if (spinner)
				this.spinner(true)

			let promises = [
				this.getJSON("SafetyJobTask/get",{include: ["SafetyHazard","SafetyControl"]}),
				this.getJSON("SafetyHazard/get"),
				this.getJSON("SafetyControl/get")
			]

			Promise.all(promises).then(responses => {

				if (spinner)
					vm.spinner(false)

				vm.tasks = responses[0].data
				vm.hazards = responses[1].data
				vm.controls = responses[2].data
			})
		}
	},
	created() {
		this.fetchData()
	}

}
</script>

<style scoped>
	form {
		margin-left: 15px;
		margin-right: 15px;
	}
</style>